import { Link } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'
import { forwardChannel } from '@/lib/routing'
import styles from './BackToFactoryLink.module.scss'

/**
 * Back link rendered above the form card on each factory page. Forwards
 * ``?channel=`` so returning to the selector keeps the user's channel
 * context — same trick the selector uses on the way in.
 */
export function BackToFactoryLink() {
  return (
    <div className={styles.row}>
      <Link to="/factory" search={forwardChannel} className={styles.link}>
        <ArrowLeft aria-hidden />
        Voltar para factories
      </Link>
    </div>
  )
}
